export default __webpack_public_path__ + "static/media/s2s_linear_gradient.6d94eb66.png";